import type { GroupByType } from 'leaderboard/scripts/swing-path/types/globals'

export default function getTypeText(type: GroupByType) {
    switch (type) {
        case 'pitching-team':
        case 'batting-team':
            return 'Team'
        case 'league':
            return 'Row'
        case 'batter':
        case 'pitcher':
        default:
            return 'Player'
    }
}
